import moment from 'moment-timezone';
import { CREATORS_PAGE_COUNT } from '../../Utils/Constants';
export const GET_ADMIN_WEBINARS_REQUEST = 'GET_ADMIN_WEBINARS_REQUEST';
export const GET_ADMIN_WEBINARS_FAILURE = 'GET_ADMIN_WEBINARS_FAILURE';
export const GET_ADMIN_WEBINARS_SUCCESS = 'GET_ADMIN_WEBINARS_SUCCESS';
export const TOGGLE_ADMIN_WEBINAR = 'TOGGLE_ADMIN_WEBINAR';
export const TOGGLE_ALL_ADMIN_WEBINARS = 'TOGGLE_ALL_ADMIN_WEBINARS';
export const GET_WEBINAR_CREATORS_REQUEST = 'GET_WEBINAR_CREATORS_REQUEST';
export const GET_WEBINAR_CREATORS_SUCCESS = 'GET_WEBINAR_CREATORS_SUCCESS';
export const GET_WEBINAR_CREATORS_FAILURE = 'GET_WEBINAR_CREATORS_FAILURE';
export const RESET_WEBINAR_CREATORS_REQUEST = 'RESET_WEBINAR_CREATORS_REQUEST';

export function getAdminWebinars(
  accountKey,
  fromTime = moment()
    .subtract(2, 'year')
    .add(1, 'd')
    .startOf('day')
    .toISOString(),
  toTime = moment()
    .add(1, 'year')
    .endOf('day')
    .toISOString(),
  creators = [],
  filter = '',
  page = 0,
  limit = 20,
  loadPage = true
) {
  return {
    type: GET_ADMIN_WEBINARS_REQUEST,
    payload: { accountKey, fromTime, toTime, creators, filter, page, limit, loadPage }
  };
}

export function toggleAdminWebinar(webinarKey, isSelected) {
  return {
    type: TOGGLE_ADMIN_WEBINAR,
    payload: { webinarKey, isSelected }
  };
}

export function toggleAllAdminWebinars(isSelected = true) {
  return {
    type: TOGGLE_ALL_ADMIN_WEBINARS,
    payload: { isSelected }
  };
}

export function getWebinarCreators(
  accountKey,
  fromTime = moment()
    .subtract(2, 'year')
    .add(1, 'd')
    .startOf('day')
    .toISOString(),
  toTime = moment()
    .add(1, 'year')
    .endOf('day')
    .toISOString(),
  page = 0,
  filter,
  limit = CREATORS_PAGE_COUNT,
  loadCreators = false
) {
  return {
    type: GET_WEBINAR_CREATORS_REQUEST,
    payload: { accountKey, fromTime, toTime, page, filter, limit, loadCreators }
  };
}

export function resetWebinarCreators() {
  return {
    type: RESET_WEBINAR_CREATORS_REQUEST
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/AdminWebinars/AdminWebinarsActions.js